import React from 'react';
import PropTypes from "prop-types";

import {ValidatedInput} from "../../components/validated-input"

/**
 * Reusable component for rendering generic number form field
 *
 * @param {string}                 value - input value
 * @param {boolean|string}         error - whether or not the input should show the error view. When string, contains the error message
 * @param {function}               onChange - onChange event handler
 * @param {string}                 controlId - input control id
 */
export function NumberField(props) {
    return (
        <ValidatedInput
            required={true}
            {...props}
            type="number"
        />
    );
}

NumberField.propTypes = {
    value: PropTypes.oneOfType([PropTypes.number]),
    error: PropTypes.oneOfType([PropTypes.bool, PropTypes.string, PropTypes.arrayOf(PropTypes.string)]),
    onChange: PropTypes.func,
    controlId: PropTypes.string,
};
